module.exports = __webpack_public_path__ + "img/capitano 4.acc7a51f.jpeg";